import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
import { deepCopy } from "@/utils/validate.js";
import { Loading } from "element-ui";
import CaLock from "@/components/common/calock";
// 引入历史核验页面
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";
// 引入项目信息页面
import ProjectInfoChoose from "../projectInfoChoose/index.vue";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        announcementId: null, // 招标公告编号
        registrationId: null, // 招标登记编号
        tenderReference: null, // 招标编号
        prjName: null, // 项目名称
        section: null, // 标段号
        regulators: null, // 行政监督部门
        tenderCorpName: null, // 招标人
        tenderLinkMan: null, // 招标联系人
        tenderAgentOrganName: null, // 招标代理机构
        agencyLinkMan: null, // 代理机构联系人
        openingTime: null, // 开标时间
        oldTenderValidityDay: null, // 原投标有效期（日历天）
        oldTenderValidity: null, // 原投标有效期截止时间
        tenderValidityChangeDay: null, // 变更后的投标有效期（日历天）
        endDate: null, // 变更后的投标有效期截止时间
        changeReason: null, // 变更原因
        state: null, // 状态
        stateName: null, // 状态名称
        tenderOpinion: null, // 招标人意见
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
        timeStamp: null // 时间戳
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        announcementId: null, // 招标公告编号
        registrationId: null, // 招标登记编号
        tenderReference: null, // 招标编号
        prjName: null, // 项目名称
        section: null, // 标段号
        regulators: null, // 行政监督部门
        tenderCorpName: null, // 招标人
        tenderLinkMan: null, // 招标联系人
        tenderAgentOrganName: null, // 招标代理机构
        agencyLinkMan: null, // 代理机构联系人
        openingTime: null, // 开标时间
        oldTenderValidityDay: null, // 原投标有效期（日历天）
        oldTenderValidity: null, // 原投标有效期截止时间
        tenderValidityChangeDay: null, // 变更后的投标有效期（日历天）
        endDate: null, // 变更后的投标有效期截止时间
        changeReason: null, // 变更原因
        state: null, // 状态
        stateName: null, // 状态名称
        tenderOpinion: null, // 招标人意见
        lockNo: null, // 锁编号
        digitalSignature: null, // 数字签名
        timeStamp: null // 时间戳
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: this.$route.query.type, // 操作标志
      id: this.$route.query.id, // 主键
      isTenderSignature: this.$route.query.isTenderSignature, // 是否甲方确认
      /************************甲方确认使用**************************/
      // 甲方确认表单
      tenderSignedForm: {
        table: null, // 表名
        key: null, // 字段
        recordNumber: null, // 数据编号
        tenderOpinion: null, // 招标人意见
        tenderSignedId: null, // 招标人签章确认编号
        tenderSignedState: null, // 招标人签章状态
        isDeregulation: null, // 添加标记
        esRegulators: null, // 招标人盖章确认的招标监管部门
        esProcessType: null, // 招标人盖章确认的招标监管流程
        esInvitationId: null, // 招标人盖章确认权限编号
        tenderStampData: null, // 招标人盖章的数字签名
        title: null // 判断当前时提交还是退还至招标代理
      },
      // 用于判断状态图片
      flagState: null
    };
  },
  // 注册组件
  components: {
    CaLock, // CA锁
    AuditHistoryRecord, // 核验记录
    ProjectInfoChoose // 项目信息
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 获取详情信息
      this.fun_Details();
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
    // 如果是修改或者新增
    else if (this.controllerFlg == "update" || this.controllerFlg == "insert") {
      // 如果是修改
      if (this.controllerFlg == "update") {
        // 获取详情信息
        this.fun_Details();
      }
      // 定义变更后的投标有效期截止时间
      let arr = ["endDate"];
      // 删除字段
      this.formConfigList[1].formConfigList = this.formConfigList[1].formConfigList.filter(
        e => !arr.includes(e.value)
      );
    }
    // 默认全部展开
    this.$refs.collapseForm.activeNames = this.formConfigList.map(item => {
      return item.name;
    });
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/tenderValidityChange/detail", {
        id: this.id, // 主键
        isTenderSignature: this.isTenderSignature // 是否甲方确认
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data.model;
          // 获取状态用于判断显示图片
          this.flagState = data.model.state;
          // 设置甲方确认
          this.fun_GetTenderSignature(data);
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 保存修改
     * @param e
     */
    fun_InsUpd(e) {
      // 设置状态
      this.form.state = e;
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 如果是提交
          if (e == "tj") {
            // 开启弹窗
            this.$refs.caLock.dialogCalock = true;
            // 签名数据, 交易人名称和日期
            this.$refs.caLock.data =
              this.form.announcementId +
              this.form.prjName +
              this.form.regulators +
              this.form.tenderReference;
            // 状态
            this.$refs.caLock.state = e;
          } else {
            // 提交的方法
            this.fun_Submit();
          }
        } else {
          return false;
        }
      });
    },
    /**
     * 保存或修改的方法
     * @author shuhua
     */
    fun_SaveOrUpdate(state, lockNo, digitalSignature) {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // ca弹窗关闭
      this.$refs.caLock.dialogCalock = false;
      // 赋值锁编号
      this.form.lockNo = lockNo;
      // 赋值数字签名
      this.form.digitalSignature = digitalSignature;
      // 不为空
      if (this.title != "" && this.title != null) {
        // 招标人提交
        this.fun_TenderStampSubmit();
      } else {
        // 确定的方法
        this.fun_Submit();
      }
    },
    /**
     * 确定的方法
     */
    fun_Submit() {
      // 全局加载框
      this.fullLoading = Loading.service({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
      try {
        // 请求
        fun_PostAction("/tenderValidityChange/saveOrUpdate", {
          ...this.form, // form表单数据
          controllerFlg: this.controllerFlg // 操作标志
        }).then(res => {
          // 加载框取消
          this.fullLoading.close();
          // 解构res.data
          const { result, data, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.fun_Back();
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
          // 关闭loading
          this.loading = false;
        });
      } catch (e) {
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("操作失败！" + e);
        // 加载框取消
        this.fullLoading.close();
      }
    },
    /**
     * 项目信息选择
     * @param e
     */
    fun_GetProjectList(e) {
      // 打开弹框
      if (e == "open") {
        // 打开弹窗
        this.$refs.projectInfoChoose.dialogVisible = true;
        // 请求接口
        this.$refs.projectInfoChoose.fun_GetOpen();
      } else {
        // 清空招标公告编号
        this.form.announcementId = "";
        // 清空招标登记编号
        this.form.registrationId = "";
        // 清空项目名称
        this.form.prjName = "";
        // 清空标段号
        this.form.section = "";
        // 清空招标编号
        this.form.tenderReference = "";
        // 清空招标投标监管部门
        this.form.regulators = "";
        // 清空原投标有效期
        this.form.oldTenderValidityDay = "";
        // 清空招标人
        this.form.tenderCorpName = "";
        // 清空招标联系人
        this.form.tenderLinkMan = "";
        // 清空招标代理机构
        this.form.tenderAgentOrganName = "";
        // 清空招标代理机构联系人
        this.form.agencyLinkMan = "";
        // 清空开标时间
        this.form.openingTime = "";
        // 清空原投标有效期截止时间
        this.form.oldTenderValidity = "";
      }
    },
    /**
     * 设置项目信息
     */
    fun_SetProjectList(e) {
      // 清空招标公告编号
      this.form.announcementId = e.announcementId;
      // 清空招标登记编号
      this.form.registrationId = e.registrationId;
      // 清空项目名称
      this.form.prjName = e.prjName;
      // 清空标段号
      this.form.section = e.section;
      // 清空招标编号
      this.form.tenderReference = e.tenderReference;
      // 清空招标投标监管部门
      this.form.regulators = e.regulators;
      // 清空原投标有效期
      this.form.oldTenderValidityDay = e.oldTenderValidity;
      // 清空招标人
      this.form.tenderCorpName = e.tenderCorpName;
      // 清空招标联系人
      this.form.tenderLinkMan = e.tenderLinkMan;
      // 清空招标代理机构
      this.form.tenderAgentOrganName = e.tenderAgentOrganName;
      // 清空招标代理机构联系人
      this.form.agencyLinkMan = e.agencyLinkMan;
      // 清空开标时间
      this.form.openingTime = e.openingTime;
      // 清空原投标有效期截止时间
      this.form.oldTenderValidity = e.endDate;
      // 关闭loading
      this.loading = false;
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * 甲方确认
     */
    fun_GetTenderSignature(data) {
      this.form.tenderOpinion = data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.table = data.model.tableName; // 表名
      this.tenderSignedForm.key = data.model.keyState; // 字段
      this.tenderSignedForm.recordNumber = data.model.id; // 数据编号
      this.tenderSignedForm.tenderOpinion = data.tenderOpinion; // 招标人意见
      this.tenderSignedForm.tenderSignedId = data.tenderSignedId; // 招标人签章确认编号
      this.tenderSignedForm.tenderSignedState = data.tenderSignedState; // 招标人签章状态
      this.tenderSignedForm.isDeregulation = data.isDeregulation; // 添加标记
      this.tenderSignedForm.esRegulators = data.esRegulators; // 招标人盖章确认的招标监管部门
      this.tenderSignedForm.esProcessType = data.esProcessType; // 招标人盖章确认的招标监管流程
      this.tenderSignedForm.esInvitationId = data.esInvitationId; // 招标人盖章确认权限编号
      this.tenderSignedForm.tenderStampData = data.tenderStampData; // 招标人盖章的数字签名
      //  招标人签章状态为提交，斌且状态等于1
      if (data.tenderSignedState == "tj" && data.isDeregulation != "1") {
        // 遍历
        this.formConfigList.map((value, index) => {
          // 招标人意见
          if (value.title === "招标人意见") {
            // 遍历
            this.formConfigList[index].formConfigList.map(j => {
              // 如果是招标人意见
              if (j.value == "tenderOpinion") {
                // 可编辑
                j.disabled = false;
              }
            });
          }
        });
      } else {
        // 遍历
        this.formConfigList.map((value, index) => {
          // 招标人意见
          if (value.title === "招标人意见") {
            // 遍历
            this.formConfigList[index].formConfigList.map(j => {
              // 如果是招标人意见
              if (j.value == "tenderOpinion") {
                // 不可编辑
                j.disabled = true;
              }
            });
          }
        });
      }
    },
    /**
     * 甲方确认提交与退还
     */
    fun_TenderStamp(e) {
      // 如果招标人意见不为空
      if (this.form.tenderOpinion != "" && this.form.tenderOpinion != null) {
        // 设置招标人意见
        this.tenderSignedForm.tenderOpinion = this.form.tenderOpinion;
      }
      // 开启弹窗
      this.$refs.caLock.dialogCalock = true;
      // 签名数据, 交易人名称和日期
      this.$refs.caLock.data = this.form.id + this.form.tenderPrjName;
      // 状态
      this.$refs.caLock.state = e;
      this.$refs.caLock.tenderSigned = e;
      this.$refs.caLock.tenderSignedForm = this.tenderSignedForm;
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
